export const BASE_URL = process.env.REACT_APP_BASE_URL + "/api/v1";
export const ADMIN_BASE_URL = process.env.REACT_APP_BASE_URL + "/api/v1/admins";
